import React from 'react';
import styled from 'styled-components';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/loading_spinner'. 'node_modules/@grnhse/seedling/lib/azalea/components/loading_spinner.js' implicitly has an 'any' type.
import LoadingSpinner from '@grnhse/seedling/lib/azalea/components/loading_spinner';
import { useBonsai } from '@grnhse/bonsai/lib/hooks';

type Props = {
  size: string;
  bonsaiEnabled?: boolean;
};

const SubmitSpinner = (props: Props) => {
  const { bonsaiEnabled, size } = props;

  const { dropdownSelectionColor } = useBonsai();

  return (
    <Container bonsaiEnabled={bonsaiEnabled} color={dropdownSelectionColor}>
      <LoadingSpinner size={size} />
    </Container>
  );
};

// Position in center of screen: https://stackoverflow.com/a/36466785/16120807
const Container = styled.div<{ bonsaiEnabled?: boolean; color?: string }>`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  & div {
    ${({ bonsaiEnabled, color }) =>
      bonsaiEnabled &&
      `
    border-top-color: ${color};
    border-right-color: ${color};
    border-bottom-color: ${color};
    border-left-color: transparent;
    `}
  }

  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export default SubmitSpinner;
